<template>
  <div class="card">
        <h5>{{title}}</h5>
        <hr>
        
        <div class="container p-0 m-0">
					<div class="row mb-2">
						<BasicTextInput
							class="col"
							placeholder=""
							label="First Name"
							v-model="colleague.FirstName"/>

						<BasicTextInput
							class="col"
							placeholder=""
							label="Last Name"
							v-model="colleague.LastName"/>
					</div>

					<div class="row mb-2">
						<BasicTextInput 
							class="col" 
							placeholder="" 
							label="Code" 
							v-model="colleague.Code"/>

						<BasicTextInput
							class="col"
							placeholder=""
							label="Phone"
							v-model="colleague.Phone"/>

						<BasicDropdown
							class="col"
							placeholder=""
							label="Title"
							v-model="colleague.Title"
							:items="titleOptions"/>
					</div>

					<div class="row mb-2">
						<BasicTextInput
							class="col"
							placeholder=""
							label="Email"
							v-model="colleague.Email"/>
					</div>

					<div class="row mb-2 groups-label">
						<label><b>Groups</b></label>
					</div>

					<div class="row mb-2 groups-select">
						<div class="form-group">
							<v-select label="Name"
								v-model="selectedGroups"
								multiple
								:options="groupOptions" 
								:reduce="group => group"
								class="group-select" />
						</div>
					</div>

					<div class="row mb-2">
						<button type="button" class="col btn btn-primary"  style="margin-top: 15px;" @click="saveColleague">Save</button>
					</div>

				</div>
      </div>
</template>

<script>
import { BasicTextInput, BasicDropdown } from '.';
import { DealerService } from '@/services';
import { mapState } from 'vuex';

export default {
  name: 'EditColleagueForm',
  props:{
    value:{
      type: Object,
      default: () => {}
    },
		title: {
			type: String,
			default: 'Edit Colleague'
		}
  },
  data(){
    return{
      colleague: this.value,
			groups: [],
			selectedGroups: [],
			titleOptions: [
				{ text: 'CSS', value: 'CSS'},
				{ text: 'EC', value: 'EC'},
				{ text: 'ESS', value: 'ESS'},
				{ text: 'FSC', value: 'FSC'},
				{ text: 'SMES', value: 'SMES'},
				{ text: 'SMM', value: 'SMM'},
				{ text: 'TSS', value: 'TSS'},
			]
    }
  },
	computed: {
    ...mapState(['currentUser']),
		groupOptions() {
			return this.groups.sort(function(a, b) {
				var textA = a.RegionCode.toUpperCase();
				var textB = b.RegionCode.toUpperCase();
				return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			});
		},
	},
	mounted() {
		//console.log('colleague', this.colleague);
		this.getGroupOptions();
		this.selectedGroups = (this.colleague.Groups ?? []).map(g => {
			return {
				Id: g.GroupId,
				Name: g.GroupName,
			}
	});
	},
  methods: {
		getGroupOptions() {
			const user = this.currentUser;
			const dealerId = user.DealerId;

			DealerService.groups(dealerId).then(res => {
				//console.log('groups', res);
				this.groups = res;
			}).catch(err => {
				this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
			})
		},
		saveColleague() {
      let newColleagueData = this.getColleagueValues();
			this.$emit('closeColleagueEdit', newColleagueData)
			return;
    },
    getColleagueValues() {
			console.log('selectedGroups', this.selectedGroups);

      let newValues = {
        Id: this.colleague.Id,
				Code: this.colleague.Code,
				FirstName: this.colleague.FirstName,
				LastName: this.colleague.LastName,
				Name: `${this.colleague.FirstName} ${this.colleague.LastName}`,
				Email: this.colleague.Email,
				Phone: this.colleague.Phone,
				Title: this.colleague.Title,
				Groups: this.selectedGroups.map(g => g.Name),
      }

      return newValues
    },
  },
}

</script>

<style lang="scss" scoped>
  .card{ 
    width: 550px;
    padding: 25px;
    .modal-card {
      background-color: white;
    }
  }

	.groups-label {
		margin: 0;
		margin-top: 10px;
	}

	.groups-select {
		margin: 0;
		margin-top: -10px;
		width: 100%;

		.form-group {
			width: 100%;
		}
	}
</style>